export const SEQUENCE_SPEED = 1000
export const COLORS = ['green', 'red', 'blue', 'yellow']
export const MAX_LEVEL = 10
export const ANIMATION_DURATION = 500
export const REPOSITORY = 'https://github.com/anthony2025/react-simon-game'



// WEBPACK FOOTER //
// ./src/utils/constants.js